import * as React from "react";
import SpecificationsList, {
    ISpecification
} from "../../../components/specifications-list/specifications-list";
import Tabs, { ITab } from "../../../components/tabs/tabs";
import TabMenu from "../../../components/tabs/tab-menu/tab-menu";
import TabContentContainer from "../../../components/tabs/tab-content-container/tab-content-container";
import TabContent from "../../../components/tabs/tab-content/tab-content";
import { IProduct } from "../../../types/product";
import ShowMore from "../../../components/show-more/show-more";
import { ProductSignupCtaProps } from "../../../components/product-signup-cta/product-signup-cta";

export interface IProductDescriptionProps {
    productDescriptionShowMoreButton: string;
    productDescriptionShowLessButton: string;

    productDescriptionTab: string;
    productDescription: IProduct["description"];

    productSpecificationsTab: string;
    productSpecifications: ISpecification[];

    productPressSpecificationsTab: string;
    productPressSpecifications: ISpecification[];
}

const enum tabTypes {
    DESCRIPTION = "description",
    SPECIFICATIONS = "specifications",
    PRESS = "press"
}

const ProductDescription: React.FC<IProductDescriptionProps & Partial<ProductSignupCtaProps>> = props => {
    const baseClass = "product-description";

    const tabs: ITab[] = [
        {
            key: tabTypes.DESCRIPTION,
            label: props.productDescriptionTab,
            content: (
                <ShowMore
                    className={`${baseClass}__container`}
                    minHeight={335}
                    btnLabelShowMore={props.productDescriptionShowMoreButton}
                    btnLabelShowLess={props.productDescriptionShowLessButton}
                >
                    {props.productDescription && (
                        <div
                            className={`${baseClass}__rich-text content-rich-text`}
                            dangerouslySetInnerHTML={{ __html: props.productDescription }}
                        />
                    )}
                </ShowMore>
            )
        },
        {
            key: tabTypes.SPECIFICATIONS,
            label: props.productSpecificationsTab,
            content: <SpecificationsList specifications={props.productSpecifications} />
        },
        {
            key: tabTypes.PRESS,
            label: props.productPressSpecificationsTab,
            content: <SpecificationsList specifications={props.productPressSpecifications} />
        }
    ];

    // const { productSignupCtaTitle, productSignupCtaText, productSignupCtaLink } = props;

    return (
        <div className={baseClass}>
            {/* {productSignupCtaTitle && productSignupCtaText && productSignupCtaLink && (
                <ProductSignupCta
                    productSignupCtaTitle={productSignupCtaTitle}
                    productSignupCtaText={productSignupCtaText}
                    productSignupCtaLink={productSignupCtaLink}
                />
            )} */}
            <Tabs
                className={`${baseClass}__tabs`}
                defaultTab={tabs[0]}
                render={({ tabClickHandler, selectedTabKey }) => (
                    <>
                        <TabMenu tabClickHandler={tabClickHandler} tabs={tabs} selectedKey={selectedTabKey} />
                        <TabContentContainer>
                            {tabs.map(tab => (
                                <TabContent isCurrent={selectedTabKey === tab.key} key={tab.key}>
                                    {tab.content}
                                </TabContent>
                            ))}
                        </TabContentContainer>
                    </>
                )}
            />
        </div>
    );
};

export default ProductDescription;
